import React, {useEffect, useState} from "react";
import {useStateValue} from "../../states/StateProvider";
import Api from "../../Api/api";
import {useParams} from "react-router";
import {toast} from "react-toastify";
import {AES, enc} from "crypto-js";
import {BeatLoader, ClipLoader} from "react-spinners";

const ReportingUpselling = () => {
    const [stepsLoading, setStepsLoading] = useState(false)
    const [info, setInfo] = useState([])
    const [data, setData] = useState([])
    const [options, setOptions] = useState([])
    const [infoLoading, setInfoLoading] = useState(false)
    const [{secretKey, portal}, dispatch] = useStateValue();

    useEffect(() => {
        setInfoLoading(true)
        Api().get(`/sp_getUpsellingReports/dgg`).then(res => {
            setInfo(res.data)
            setInfoLoading(false)
        }).catch(e => {
            toast.error('Firmendetails konnten nicht geladen werden!')
            setInfoLoading(false)
        })

        Api().get(`sp_getUpsellingOptions/${'dgg'}`)
            .then(res => {
                setOptions(res.data)
            })

    }, []);


    function optionSelected(e) {
        if (e.target.value === 'Wähle eine Option') {
            toast.warning('Wählen Sie zunächst eine Option')
        } else {
            setStepsLoading(true)
            Api().get(`/sp_getSingleUSReport/${portal}/${e.target.value}`).then(res => {
                res.data.map(d => {
                    options.map(o => {
                        if (d.usID === o.ID) {
                            d.title = o.title
                        }
                    })
                    if (d.title === "Fremdvertrag") {
                        d.separate = true
                    } else {
                        d.separate = false
                    }
                    d.gesamt = parseInt(d.bAV) + parseInt(d.CLS) + parseInt(d.GE) + parseInt(d.bKV) + parseInt(d.NBG) + parseInt(d.bBU) + parseInt(d.HRMT)
                })
                setData(res.data)
                setStepsLoading(false)
            }).catch(e => {
                toast.error('Firmendetails konnten nicht geladen werden!')
                setStepsLoading(false)
            })
        }
    }

    function portalSelect(e) {
        dispatch({type: 'SET_PORTAL', item: e.target.value})
        localStorage.setItem('portal', e.target.value)
        setData([])
    }

    return (<div className='dashboardContainer'>
        <h2 className={`text-2xl lg:text-left float-left ${!infoLoading ? '' : 'opacity-0'}`}>Upselling-Übersicht</h2>

        {infoLoading && <tr className='centerItemsAbsolute'>
            <td><BeatLoader size={50} color={'#b4b4b4'}/></td>
        </tr>}
        {!infoLoading && <section className='inline-block'>
            <span>Wählen Sie eine Tabelle aus</span>
            <select onChange={optionSelected}
                    className='bg-white border ml-4 my-2 px-5 py-2 border-offWhite rounded-lg'>
                <option value={null}>Wähle eine Option
                </option>
                :
                {info.map(i => (<option key={i.ID} value={i.ID}>{i.Auswertung}</option>))}
            </select>
        </section>

        }
        {/*{<div className='inline-block ml-5'>*/}
        {/*    <label className='my-3'>Vertrieb: </label>*/}
        {/*    <select*/}
        {/*        disabled={infoLoading}*/}
        {/*        className='bg-white border px-5 py-2 border-offWhite rounded-lg'*/}
        {/*        onChange={portalSelect}*/}
        {/*        value={portal}*/}
        {/*    >*/}
        {/*        <option selected value='dgg'>DGG</option>*/}
        {/*        <option value='hsg'>HSG</option>*/}
        {/*    </select>*/}
        {/*</div>}*/}
        {stepsLoading && <tr className='centerItemsAbsolute'>
            <td><ClipLoader size={50} color={'#b4b4b4'}/></td>
        </tr>}
        {!stepsLoading && data.length > 0 && <div className='my-3 rounded-lg sm:block w-12/12 bg-white'>
            <table className='text-left table bg-white w-full'>
                <thead>
                <tr>
                    <th scope="col" className="text-grey pl-1.5">
                        Upselling-Phase
                    </th>
                    <th scope="col" className="text-grey pl-1.5">
                        Gesamt
                    </th>
                    <th scope="col" className="text-grey pl-1.5">
                        bAV
                    </th>
                    <th scope="col" className=" text-grey pl-1.5">
                        CLS
                    </th>
                    <th scope="col" className=" text-grey pl-1.5">
                        GehaltsExtras
                    </th>
                    <th scope="col" className=" text-grey pl-1.5">
                        bKV
                    </th>
                    <th scope="col" className=" text-grey pl-1.5">
                        NBG KoV
                    </th>
                    <th scope="col" className=" text-grey pl-1.5">
                        bBU
                    </th>
                    <th scope="col" className="text-grey pl-1.5">
                        HRMT Pro
                    </th>
                </tr>
                </thead>
                <tbody className='gap-4'>
                {data.map((d) => (<tr key={d.usID}
                                      className={`border-y border-silver border-x-0 text-sm ${d.separate ? 'border-b-4' : ''}`}>
                    <td>{d.title}</td>
                    <td>{d.gesamt}</td>
                    <td>{d.bAV}</td>
                    <td>{d.CLS}</td>
                    <td>{d.GE}</td>
                    <td>{d.bKV}</td>
                    <td>{d.NBG}</td>
                    <td>{d.bBU}</td>
                    <td>{d.HRMT}</td>
                </tr>))}
                </tbody>
            </table>
        </div>}
    </div>)
}

export default ReportingUpselling
